import "../assets/css/credit.css"
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../Firebase/AuthContext";

function Credits() {
  const { currentUser,logout } = useAuth();

  function decideLogout(){
    if (window.location.pathname === "/Admin"){
      signout()
    }
  }
  async function signout(){
    logout();
  }
  return (
    <div>
      <div className="credits">
        Designed by 
        {
          !currentUser && (<Link  to="/AdminLogin"> Justin Dsouza</Link>)
        }
        {
          currentUser && (<Link  to="/Admin" onClick={decideLogout}> Justin Dsouza</Link>)
        }
      </div>
    </div>
  );
}

export default Credits;
